import { render, staticRenderFns } from "./demoDialog.vue?vue&type=template&id=3f1155d8&scoped=true"
import script from "./demoDialog.vue?vue&type=script&lang=js"
export * from "./demoDialog.vue?vue&type=script&lang=js"
import style0 from "./demoDialog.vue?vue&type=style&index=0&id=3f1155d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1155d8",
  null
  
)

export default component.exports